export const manifest = {
    name: "Platform Webshop",
    short_name: "Webshop",
    description: "Ecommerce platform",
    theme_color: "#0277bd",
    display: "standalone",
    start_url: ".",
    background_color: "#121212",
    icons: [
        {
            src: "logo.webp",
            type: "image/webp",
            sizes: "512x512 192x192 64x64 32x32 24x24 16x16",
            purpose: "any",
        },
    ],
};
